//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export enum CONFIRMATION_MODAL_ACTIONS {
  TOGGLE_DISCONNECT_MODAL = 'CONFIRMATION_MODAL_ACTIONS/TOGGLE_DISCONNECT_MODAL',

  TOGGLE_IG_CONFIRMATION_MODAL = 'CONFIRMATION_MODAL_ACTIONS/TOGGLE_IG_CONFIRMATION_MODAL',

  TOGGLE_REFRESH_CONFIRMATION_MODAL = 'CONFIRMATION_MODAL_ACTIONS/TOGGLE_REFRESH_CONFIRMATION_MODAL',
}

export interface IConfirmationModalState {
  isDisconnectModalOpen: boolean;
  isIgConfirmationModalOpen: boolean;
  isRefreshConfirmationModalOpen: boolean;
}
